import { Box, Grid, IconButton, Modal } from '@material-ui/core'
import CancelIcon from '@material-ui/icons/Cancel'
import { Role, TrackingRows } from '@types'
import { InsertDriveFile as DocumentIcon } from '@material-ui/icons'
import { useState } from 'react'
import '../track.css'
import './modals.css'
import ConversationBox from '@views/shared/ConversationBox'
import DocumentsPanel from '../components/DocumentsPanel'

interface Props {
  row: TrackingRows
  role: Role
  isAddEnable: boolean
}

const ModalIcon: React.FC<Props> = ({ row, role, isAddEnable }) => {
  const [isOpen, setIsOpen] = useState(false)

  const openModal = () => {
    setIsOpen(true)
  }

  const onCancel = () => {
    setIsOpen(false)
  }

  return (
    <>
      <DocumentIcon
        style={{
          color: 'rgb(255, 105, 0)',
          width: '20px',
          height: '20px',
          margin: '0 10px',
          cursor: 'pointer'
        }}
        onClick={() => openModal()}
      />
      <Modal open={isOpen} onClose={() => setIsOpen(false)} className="documents-modal">
        <form className="modal_main">
          <Grid container>
            <Grid item xs={12} md={6} style={{ padding: '10px' }}>
              <IconButton
                style={{
                  position: 'absolute',
                  top: '10px',
                  right: '10px'
                }}
                onClick={onCancel}
              >
                <CancelIcon style={{ color: '#fc6404' }}></CancelIcon>
              </IconButton>
              <DocumentsPanel
                row={row}
                role={role}
                isAddEnable={isAddEnable}
                onCancel={onCancel}
                onSaved={() => setIsOpen(false)}
              />
            </Grid>
            <Grid item xs={12} md={6} style={{ padding: '10px' }}>
              <Box fontSize="18px" fontWeight="bold" margin="10px 0 10px 0" color="#fc6404">
                Seguimiento:
              </Box>
              <ConversationBox
                conversations={row.conversation || []}
                type="executive"
                userId={row._id ?? ''}
                label="Nuevo Comentario:"
              />
            </Grid>
          </Grid>
        </form>
      </Modal>
    </>
  )
}

export default ModalIcon
